module.exports = __webpack_public_path__ + "static/media/christian-dior-joy-big.b366e23a.png";